"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateFullName = void 0;
/**
 * The "validateFullName" method tests if a string contains
 * at least 2 words with a minimum of 2 characteres each.
 *
 * @param fullName
 * @returns
 */
const validateFullName = (fullName) => {
    /**
     * Regex to match strings containing at least 2 words with a minimum
     * of 2 characteres each. Rules explained:
     *
     * 1º: ^ --> start of string.
     * 2º: [A-Za-zÀ-ÖØ-öø-ÿ]{2,} --> 2 or more character.
     * 3º: ( {1,2}[A-Za-zÀ-ÖØ-öø-ÿ]{2,}){1,} --> 2 or more words with 2 or more character.
     * 4º: $ --> end of string.
     */
    const regex = RegExp('^[A-Za-zÀ-ÖØ-öø-ÿ]{2,}( {1,2}[A-Za-zÀ-ÖØ-öø-ÿ]{2,}){1,}$');
    return regex.test(fullName.trim());
};
exports.validateFullName = validateFullName;
